import { useMutation, useQuery } from "@apollo/client/react";

import { Buy } from '../../models/buy'

export const useJustBought = () => {
  const { data } = useQuery(Buy.fetchJustBought)
  const justBought = data && data.justBought

  const [ boughtAddition ] = Buy.useJustBoughtUpdate()
  Buy.useJustBoughtDelete()
  const [ buyAdd ] = useMutation(Buy.methods.add)

  return { justBought, boughtAddition, buyAdd } 
}
